export const USER_INFO = "userInfo";
export const USER_TOKEN = "userToken";
export const REFRESH_TOKEN = "refreshToken";

export const APP_KEY = "appKey";
export const NEXT = "next";
export const COMPANY_ID = "cid";
